<ng-container *ngIf="tipDokumenta">
  <div class="p-fluid">
    <kodit-field fieldLabel="Dokument" fieldLabelFor="izvorna-faktura">
      <kodit-racun-autocomplete
        formCtrlId="izvorna-faktura"
        [jeIzmenaOsnovice]="jeIzmenaOsnovice"
        [includeTipoveRacuna]="useOnlyTipove"
        [includeStatuseRacuna]="useOnlyStatuse"
        (onChange)="handleVezaniRacunChange($event)"
        (onClear)="handleVezaniRacunClear()"
      ></kodit-racun-autocomplete>

      <div *ngIf="selectedRacun" class="p-mt-2 p-d-flex p-ai-center p-jc-between selected-racun">
        <span class="p-text-bold">{{ selectedRacun.label }}</span>
        <span class="p-ml-2 tip-badge">{{ selectedRacun.tipStr }}</span>
        <i class="pi pi-times p-ml-auto clear-icon" (click)="handleVezaniRacunClear()"></i>
      </div>
    </kodit-field>
  </div>
</ng-container>